<ul class="sub-menu">
  <li (click)="openTab('trailer')" [ngClass]="{ active: isTrailerOpen }">
    @if (loadingSpace.type === 1) {
      {{ 'semi_trailer' | translate }}
    }
    @if (loadingSpace.type > 1) {
      {{ 'container' | translate }} I
    }
  </li>
  @if (isSet) {
    <li (click)="openTab('semitrailer')" [ngClass]="{ active: isSemitrailerOpen }">
      @if (loadingSpace.type === 1) {
        {{ 'trailer' | translate }}
      }
      @if (loadingSpace.type > 1) {
        {{ 'container' | translate }} II
      }
    </li>
  }
</ul>
<div class="container">
  <form class="form" #f="ngForm" (keyup.enter)="onSubmit()" [formGroup]="form">
    @if (isTrailerOpen) {
      <div class="wheel-form-trailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'floor_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="floorHeight" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'width' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="width" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'height' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="height" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'length' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="length" normal-input type="text" />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    @if (isSemitrailerOpen) {
      <div class="wheel-form-semitrailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'floor_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorHeight2"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'width' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="width2" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'height' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="height2" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'length' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="length2" normal-input type="text" />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    <div class="right-column">
      @if (isTrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            view="left"
            [height]="220"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
      @if (isSemitrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            view="setLeft"
            [height]="220"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
    </div>
  </form>
  <div class="buttonRow">
    <button (click)="formReset()" outline-icon-button>
      <gl-icon name="delete"></gl-icon>
    </button>
    <button (click)="reload()" outline-icon-button>
      <gl-icon name="startArrangement"></gl-icon>
    </button>
  </div>
</div>
